import React from "react";
import {
    ApartmentOutlined,
    AppstoreAddOutlined,
    AuditOutlined,
    BookOutlined,
    CalendarOutlined,
    FileTextOutlined,
    FlagOutlined,
    FormOutlined,
    MedicineBoxOutlined,
    ProfileOutlined,
    ProjectOutlined,
    ReadOutlined,
    SafetyCertificateOutlined,
    TagsOutlined,
    TeamOutlined
} from "@ant-design/icons";

const iconOptions = [
    {value: "clipboard-list", label: "Clipboard", icon: ProfileOutlined},
    {value: "scale", label: "Legal / Case", icon: AuditOutlined},
    {value: "metadata-entity", label: "Metadata Entity", icon: ApartmentOutlined},
    {value: "text-asset", label: "Text Asset", icon: BookOutlined},
    {value: "article", label: "Article", icon: FileTextOutlined},
    {value: "book", label: "Book", icon: ReadOutlined},
    {value: "calendar", label: "Calendar", icon: CalendarOutlined},
    {value: "classification", label: "Classification", icon: TagsOutlined},
    {value: "flag", label: "Status", icon: FlagOutlined},
    {value: "form", label: "Form", icon: FormOutlined},
    {value: "medical", label: "Medical", icon: MedicineBoxOutlined},
    {value: "project", label: "Project", icon: ProjectOutlined},
    {value: "read", label: "Reading", icon: ReadOutlined},
    {value: "restricted", label: "Compliance", icon: SafetyCertificateOutlined},
    {value: "team", label: "People", icon: TeamOutlined}
];

const iconOptionByValue = iconOptions.reduce((options, option) => {
    options[option.value] = option;
    return options;
}, {});

const fallbackByKind = {
    metadata_entity: "metadata-entity",
    text_asset: "text-asset",
    entity_type: "text-asset"
};

export const configurableIconOptions = iconOptions;

function graphemeCount(value) {
    if (typeof Intl !== "undefined" && Intl.Segmenter) {
        return [...new Intl.Segmenter(undefined, {granularity: "grapheme"}).segment(value)].length;
    }
    return [...value].length;
}

export function isCustomConfigurableIcon(value) {
    if (!value || iconOptionByValue[value]) return false;
    return graphemeCount(String(value).trim()) === 1;
}

export function configurableIconLabel(value) {
    if (isCustomConfigurableIcon(value)) return "";
    return iconOptionByValue[value]?.label || value;
}

export function configurableIconSelectOptions() {
    return iconOptions.map(option => {
        const Icon = option.icon;
        return {
            value: option.value,
            label: <><Icon/> {option.label}</>
        };
    });
}

export default function ConfigurableEntityIcon({icon, kind, style, ...props}) {
    if (isCustomConfigurableIcon(icon)) {
        return (
            <span role="img" style={{marginRight: ".3em", ...(style || {})}} {...props}>
                {String(icon).trim()}
            </span>
        );
    }

    const fallback = fallbackByKind[kind] || "text-asset";
    const option = iconOptionByValue[icon] || iconOptionByValue[fallback];
    const Icon = option.icon;

    return <Icon style={{marginRight: ".3em", ...(style || {})}} {...props}/>;
}
